<div class="template-generator-container">
  <div class="title-block">
    <span class="title">{{'Generate Template' | translate}}</span>
    <img class="close-icon" alt="" tooltip="{{'Close'  | translate }}" placement="bottom" (click)="onCancel()" src="assets/icon/cancel.svg">
  </div>
  <form #templateForm="ngForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="form-group">
      <label for="reportName">{{'Report Name' | translate}} *</label>
      <input type="text" id="reportName" name="reportName" class="form-control"
        placeholder="{{'Enter Report Name' | translate}}" [(ngModel)]="templateData.reportName" #reportName="ngModel"
        required>
      <div class="error-message"
        *ngIf="reportName.invalid && (reportName.dirty || reportName.touched || formSubmitted)">
        {{'Report Name required' | translate}}
      </div>
    </div>

    <div class="form-group">
      <label for="customerVersion">{{'Customer Version' | translate}}</label>
      <input type="text" id="customerVersion" name="customerVersion" class="form-control"
        placeholder="{{'Enter Customer Version' | translate}}" [(ngModel)]="templateData.customerVersion"
        #customerVersion="ngModel" maxlength="10">
      <div class="error-message"
        *ngIf="customerVersion.errors?.maxlength && (customerVersion.dirty || customerVersion.touched || formSubmitted)">
        {{'customer_version_max_10' | translate}}
      </div>
    </div>

    <div class="form-group" *ngIf="isDateofReportUpdatePermission">
      <label for="customerVersion">{{'Date_of_Report' | translate}}</label>
      <!-- <input type="text" id="customerVersion" name="customerVersion" class="form-control"
        placeholder="{{'Enter Customer Version' | translate}}" [(ngModel)]="templateData.customerVersion"
        #customerVersion="ngModel"> -->
      <div class="date-input-container" (click)="openDatePicker()">
        <ion-input name="dateOfReport" class="report-date-input" type="text" [(ngModel)]="formattedDate"
          readonly placeholder="{{formattedDate}}">
        </ion-input>
        <ion-icon slot="end" name="calendar-outline" class="calendar-icon"
          role="button" tabindex="0" [attr.aria-label]="'Date_of_Report' | translate"
          (keydown.enter)="openDatePicker()"
          (keydown.space)="$event.preventDefault(); openDatePicker()">
        </ion-icon>
      </div>
      <!-- Hidden native date input -->
      <input #hiddenDateInput type="date" name="dateOfReportPicker" [(ngModel)]="templateData.dateOfReport" (change)="onDateChange($event)"
        [min]="projectStartDate" style="position: absolute; visibility: hidden; pointer-events: none;">
      </div>

    <div class="button-group">
      <button  type="button" class="btn btn-cancel" (click)="onCancel()">{{'Cancel' | translate}}</button>
      <button  type="submit" class="btn btn-generate" [disabled]="templateForm.invalid">{{'Generate' |
        translate}}</button>
    </div>
  </form>
</div>